import { useCart } from "../Cart/CartContext";
import { useLocation } from "react-router-dom";
import MainMenu from "./MainMenu.jsx";

export default function Header() {
  const { cart } = useCart();
  const location = useLocation();

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);

  const isCustomize = location.pathname === "/customize";
  const isCheckout = location.pathname === "/checkout";

  return (
    <header className="header">
      <img className="logo" src="../logo/WildCard_Logo.png" alt="wild card logo" />

      {(isCustomize || isCheckout) && (
        <div className="header-text">
          <h2>{isCustomize ? "Customize Each Card" : "Review & Checkout"}</h2>
          <div className="header-subinfo">
            <span><strong>${totalPrice.toFixed(2)}</strong></span>
            <span>{totalItems} item{totalItems !== 1 ? "s" : ""}</span>
          </div>
        </div>
      )}
      {(isCustomize || isCheckout) ? "" : <MainMenu /> }
    </header>
  );
}
